var map = {
	"./partners_1.png": 4758,
	"./partners_10.png": 6324,
	"./partners_10_rmv.png": 7766,
	"./partners_11.png": 7453,
	"./partners_11_rmv.png": 2763,
	"./partners_12.png": 6246,
	"./partners_12_rmv.png": 108,
	"./partners_13_rmv.png": 7785,
	"./partners_14.png": 2416,
	"./partners_14_rmv.png": 6906,
	"./partners_15.png": 8665,
	"./partners_15_rmv.png": 8959,
	"./partners_1_rmv.png": 9948,
	"./partners_2_rmv.png": 3211,
	"./partners_3.png": 8516,
	"./partners_3_rmv.png": 3574,
	"./partners_4.png": 4427,
	"./partners_4_rmv.png": 2957,
	"./partners_5.png": 3298,
	"./partners_5_rmv.png": 7200,
	"./partners_6.png": 7833,
	"./partners_6_rmv.png": 1823,
	"./partners_8.png": 1463,
	"./partners_8_rmv.png": 881,
	"./partners_9.png": 8446,
	"./partners_9_rmv.png": 7972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3108;